(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-studio"]) return;
  try {
    
  (() => {
    const studios = document.querySelectorAll('[data-design-studio]');

    studios.forEach((studio) => {
      const state = {
        templateId: null,
        uploadedImage: null,
        uploadedFile: null,
        logoImage: null,
        logoFile: null,
        aiState: 'empty',
        labelStyle: 'Loading...',
        labelPresetId: null,
        packagingStyle: 'Loading...',
        packagingPresetId: null,
        materialPresetId: null,
        referencePresets: {
          materials: [],
          brandMarks: [],
          packaging: []
        },
        message: '10 Years Together',
        resultImage: null,
        resultImages: [],
        caseId: null,
        serverCase: null,
        selectedTemplate: null,
        selectedSceneId: null,
        selectedEventId: null,
        scenes: [],
        eventsByScene: {},
        templatesByEvent: {}
      };

      const els = {
        empty: studio.querySelector('[data-preview-empty]'),
        grid: studio.querySelector('[data-preview-grid]'),
        generating: studio.querySelector('[data-preview-generating]'),
        result: studio.querySelector('[data-preview-result]'),
        resultImage: studio.querySelector('[data-result-preview]'),
        mainPreview: studio.querySelector('[data-main-preview]'),
        previewTitle: studio.querySelector('[data-preview-title]'),
        pill: studio.querySelector('[data-state-pill]'),
        copy: studio.querySelector('[data-state-copy]'),
        alert: studio.querySelector('[data-state-alert]'),
        info: studio.querySelector('[data-info-banner]'),
        summaryTitle: studio.querySelector('[data-summary-title]'),
        summary: studio.querySelector('[data-summary]'),
        summaryPreview: studio.querySelector('[data-summary-preview]'),
        summarySubtitle: studio.querySelector('[data-summary-subtitle]'),
        summaryIncludes: studio.querySelector('[data-summary-includes]'),
        generate: studio.querySelector('[data-generate-ai]'),
        regenerate: studio.querySelector('[data-regenerate-ai]'),
        progressBar: studio.querySelector('[data-progress-bar]'),
        progressPercent: studio.querySelector('[data-progress-percent]'),
        progressTitle: studio.querySelector('[data-progress-title]'),
        progressCopy: studio.querySelector('[data-progress-copy]'),
        file: studio.querySelector('[data-design-file]'),
        logoFile: studio.querySelector('[data-logo-file]'),
        uploadDrop: studio.querySelector('[data-upload-drop]'),
        toast: studio.querySelector('[data-design-toast]'),
        labelState: studio.querySelector('[data-label-state]'),
        packagingState: studio.querySelector('[data-packaging-state]'),
        autoState: studio.querySelector('[data-auto-state]'),
        styleState: studio.querySelector('[data-style-state]'),
        sizeState: studio.querySelector('[data-size-state]'),
        styleVisual: studio.querySelector('[data-style-visual]'),
        sizeVisual: studio.querySelector('[data-size-visual]'),
        logoState: studio.querySelector('[data-logo-state]'),
        logoName: studio.querySelector('[data-logo-name]'),
        logoSummaryImg: studio.querySelector('[data-logo-summary-img]'),
        logoSummaryEmpty: studio.querySelector('[data-logo-summary-empty]'),
        sourceName: studio.querySelector('[data-source-name]'),
        sourceStatus: studio.querySelector('[data-source-status]'),
        sourcePreviewEmpty: studio.querySelector('[data-source-preview-empty]'),
        sourcePreviewImg: studio.querySelector('[data-source-preview-img]'),
        sourceSummaryImg: studio.querySelector('[data-source-summary-img]'),
        sourceSummaryEmpty: studio.querySelector('[data-source-summary-empty]'),
        labelSummaryImg: studio.querySelector('[data-label-summary-img]'),
        packagingSummaryImg: studio.querySelector('[data-packaging-summary-img]'),
        brandPresetOptions: studio.querySelector('[data-brand-preset-options]'),
        packagingPresetOptions: studio.querySelector('[data-packaging-preset-options]'),
        templateModal: studio.querySelector('[data-template-modal]'),
        templateScenes: studio.querySelector('[data-template-scenes]'),
        templateEvents: studio.querySelector('[data-template-events]'),
        templateGrid: studio.querySelector('[data-template-grid]'),
        templateStatus: studio.querySelector('[data-template-status]'),
        imageModal: studio.querySelector('[data-image-modal]'),
        imageModalImg: studio.querySelector('[data-image-modal-img]'),
        imageModalCaption: studio.querySelector('[data-image-modal-caption]')
      };

      const templateSrc = els.mainPreview ? els.mainPreview.getAttribute('src') : '';
      const getInitialTemplatePreviewSrc = (key) => {
        const image = studio.querySelector(`[data-template-preview="${key}"]`);
        return image ? image.getAttribute('src') : templateSrc;
      };
      const fallbackTemplateImages = {
        mainEffect: templateSrc,
        product: getInitialTemplatePreviewSrc('product'),
        usageScene: getInitialTemplatePreviewSrc('usageScene'),
        brandMark: getInitialTemplatePreviewSrc('brandMark'),
        giftBox: getInitialTemplatePreviewSrc('giftBox')
      };
      const configuredTemplateId = studio.getAttribute('data-template-id') || '';
      let progressTimer = null;
      let activeRequestId = 0;
      let catalogRequestId = 0;
      let templateCatalogPromise = null;
      let templateCatalogError = null;
      let referencePresetPromise = null;
      let referencePresetsLoaded = false;
      let toastTimer = null;

      const getClient = () => window.PoptexApi && window.PoptexApi.getDefaultClient
        ? window.PoptexApi.getDefaultClient()
        : null;

      const getTemplateApi = () => window.PoptexDesignStudioApi || null;

      const escapeHtml = (value) => String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

      const getActiveBlanketStyle = () =>
        studio.querySelector('[data-style-choice].is-active')?.getAttribute('data-style-choice') || 'single';

      const selectMaterialForStyle = (blanketStyle) => {
        const material = state.referencePresets.materials.find((preset) =>
          preset && preset.structuredConfig && preset.structuredConfig.blanketStyle === blanketStyle
        );
        state.materialPresetId = material ? material.id : null;
        studio.querySelectorAll('[data-material-preview]').forEach((image) => {
          const targetStyle = image.getAttribute('data-material-preview');
          const target = state.referencePresets.materials.find((preset) =>
            preset && preset.structuredConfig && preset.structuredConfig.blanketStyle === targetStyle
          );
          const fallback = image.previousElementSibling;
          image.hidden = !target || !target.previewUrl;
          if (target && target.previewUrl) image.src = target.previewUrl;
          if (fallback) fallback.hidden = Boolean(target && target.previewUrl);
        });
      };

      const selectGlobalPresetDefaults = () => {
        const selectedBrand = state.referencePresets.brandMarks[0];
        const selectedPackaging = state.referencePresets.packaging[0];
        state.labelPresetId = selectedBrand ? selectedBrand.code : null;
        state.labelStyle = selectedBrand ? selectedBrand.name : 'Unavailable';
        state.packagingPresetId = selectedPackaging ? selectedPackaging.code : null;
        state.packagingStyle = selectedPackaging ? selectedPackaging.name : 'Unavailable';
        selectMaterialForStyle(getActiveBlanketStyle());
      };

      const applyTemplatePresetDefaults = (template) => {
        const material = state.referencePresets.materials.find((preset) => preset.id === template.defaultMaterialPresetId);
        const brand = state.referencePresets.brandMarks.find((preset) => preset.id === template.defaultBrandMarkPresetId);
        const packaging = state.referencePresets.packaging.find((preset) => preset.id === template.defaultPackagingPresetId);
        const activeStyle = getActiveBlanketStyle();
        state.materialPresetId = material && material.structuredConfig && material.structuredConfig.blanketStyle === activeStyle
          ? material.id
          : null;
        state.labelPresetId = brand ? brand.code : null;
        state.labelStyle = brand ? brand.name : 'Unavailable';
        state.packagingPresetId = packaging ? packaging.code : null;
        state.packagingStyle = packaging ? packaging.name : 'Unavailable';
      };

      const renderReferencePresetOptions = () => {
        if (els.brandPresetOptions) {
          els.brandPresetOptions.innerHTML = state.referencePresets.brandMarks.length
            ? state.referencePresets.brandMarks.map((preset) => `
                <button class="${preset.code === state.labelPresetId ? 'is-active' : ''}" type="button" data-label-choice="${escapeHtml(preset.name)}" data-label-preset-id="${escapeHtml(preset.code)}" aria-pressed="${preset.code === state.labelPresetId ? 'true' : 'false'}">
                  <img src="${escapeHtml(preset.previewUrl)}" alt="${escapeHtml(preset.name)} brand mark" width="900" height="675" loading="lazy">
                  <span><strong>${escapeHtml(preset.name)}</strong></span>
                </button>
              `).join('')
            : '<p class="design-option-modal__status">No brand marks are available.</p>';
        }
        if (els.packagingPresetOptions) {
          els.packagingPresetOptions.innerHTML = state.referencePresets.packaging.length
            ? state.referencePresets.packaging.map((preset) => `
                <button class="${preset.code === state.packagingPresetId ? 'is-active' : ''}" type="button" data-packaging-choice="${escapeHtml(preset.name)}" data-packaging-preset-id="${escapeHtml(preset.code)}" aria-pressed="${preset.code === state.packagingPresetId ? 'true' : 'false'}">
                  <img src="${escapeHtml(preset.previewUrl)}" alt="${escapeHtml(preset.name)} packaging" width="900" height="675" loading="lazy">
                  <span><strong>${escapeHtml(preset.name)}</strong></span>
                </button>
              `).join('')
            : '<p class="design-option-modal__status">No packaging options are available.</p>';
        }
      };

      const loadReferencePresets = () => {
        if (referencePresetsLoaded) return Promise.resolve(state.referencePresets);
        if (referencePresetPromise) return referencePresetPromise;
        const api = getTemplateApi();
        const client = getClient();
        if (!api || !api.listReferencePresets || !client) {
          return Promise.reject(new Error('Reference preset API is unavailable'));
        }
        referencePresetPromise = Promise.all([
          api.listReferencePresets(client, { type: 'MATERIAL' }),
          api.listReferencePresets(client, { type: 'BRAND_MARK' }),
          api.listReferencePresets(client, { type: 'PACKAGING' })
        ]).then(([materials, brandMarks, packaging]) => {
          state.referencePresets.materials = Array.isArray(materials) ? materials : [];
          state.referencePresets.brandMarks = Array.isArray(brandMarks) ? brandMarks : [];
          state.referencePresets.packaging = Array.isArray(packaging) ? packaging : [];
          referencePresetsLoaded = true;
          if (state.selectedTemplate) applyTemplatePresetDefaults(state.selectedTemplate);
          else selectGlobalPresetDefaults();
          renderReferencePresetOptions();
          render();
        }).finally(() => {
          referencePresetPromise = null;
        });
        return referencePresetPromise;
      };

      const copyByState = {
        empty: {
          pill: 'Design Before AI Generation',
          copy: 'Choose a template or upload your images to get started.',
          alert: 'Choose a template or upload artwork first. The preview will update here before AI generation.'
        },
        template: {
          pill: 'Before AI Generation',
          copy: 'This is the selected template preview. Start customization to generate the AI result.',
          alert: 'Template preview only. Click “Start Customizing” to generate the final AI preview.'
        },
        uploaded: {
          pill: 'Uploaded Artwork Preview',
          copy: 'Your uploaded image is ready for customization.',
          alert: 'Uploaded artwork preview. Choose brand mark and packaging styles before starting customization.'
        },
        designing: {
          pill: 'AI Design In Progress',
          copy: 'Your design request has been submitted. Waiting for the AI image response.',
          alert: 'Designing is in progress. The final image will appear only after the design service returns it.'
        },
        designed: {
          pill: 'AI Design Ready',
          copy: 'Review the generated preview, then continue to confirm details and quantity.',
          alert: 'Your AI preview is ready. You can continue to review or adjust options and generate again.'
        }
      };

      const showToast = (message) => {
        if (!els.toast) return;
        els.toast.textContent = message;
        els.toast.classList.add('is-visible');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => els.toast.classList.remove('is-visible'), 2200);
      };

      const setHidden = (el, hidden) => {
        if (el) el.hidden = hidden;
      };

      const setActiveInGroup = (selector, valueAttr, value) => {
        studio.querySelectorAll(selector).forEach((button) => {
          const isActive = button.getAttribute(valueAttr) === value;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      const getTemplatePreviewImages = (template) => Object.assign(
        {},
        template && template.previewImages ? template.previewImages : {}
      );

      const getTemplateImage = (template, key) => {
        const images = getTemplatePreviewImages(template);
        return images[key] || '';
      };

      const getCurrentTemplateImage = (key) => getTemplateImage(state.selectedTemplate, key);

      const setPreviewImage = (image, imageUrl, fallbackUrl) => {
        if (!image) return;
        const figure = image.closest('figure');
        const nextSrc = imageUrl || fallbackUrl || '';
        image.hidden = !nextSrc;
        if (figure) figure.classList.toggle('is-empty', !nextSrc);
        if (nextSrc) {
          image.src = nextSrc;
        } else {
          image.removeAttribute('src');
        }
      };

      const render = () => {
        studio.setAttribute('data-state', state.aiState);

        const content = copyByState[state.aiState] || copyByState.empty;
        if (els.previewTitle) {
          els.previewTitle.textContent = state.aiState === 'template' ? 'Template Preview' : 'AI Preview';
        }
        if (els.pill) els.pill.textContent = content.pill;
        if (els.copy) els.copy.textContent = content.copy;
        if (els.alert) els.alert.textContent = content.alert;

        setHidden(els.empty, state.aiState !== 'empty');
        setHidden(els.grid, !(state.aiState === 'template' || state.aiState === 'uploaded'));
        setHidden(els.generating, state.aiState !== 'designing');
        setHidden(els.result, state.aiState !== 'designed');
        setHidden(els.summary, state.aiState === 'designing');

        if (els.mainPreview) {
          const mainImage = state.uploadedImage || (state.templateId ? getCurrentTemplateImage('mainEffect') : '');
          setPreviewImage(els.mainPreview, mainImage, state.templateId ? '' : templateSrc);
        }

        if (els.sourcePreviewImg && els.sourcePreviewEmpty) {
          const sourceImage = state.uploadedImage || (state.templateId ? getCurrentTemplateImage('mainEffect') : '');
          els.sourcePreviewImg.hidden = !sourceImage;
          els.sourcePreviewEmpty.hidden = Boolean(sourceImage);
          if (sourceImage) els.sourcePreviewImg.src = sourceImage;
        }

        studio.querySelectorAll('[data-template-preview]').forEach((image) => {
          const key = image.getAttribute('data-template-preview');
          setPreviewImage(image, state.templateId ? getCurrentTemplateImage(key) : '', state.templateId || state.uploadedImage ? '' : fallbackTemplateImages[key]);
        });

        if (els.resultImage) {
          if (state.aiState === 'designed' && state.resultImages.length) {
            const roleLabels = {
              MAIN_EFFECT_IMAGE: 'Main Effect',
              PRODUCT_IMAGE: 'Product',
              USAGE_SCENE_IMAGE: 'Lifestyle',
              BRAND_MARK_DETAIL_IMAGE: 'Brand Mark',
              PACKAGING_IMAGE: 'Packaging',
              GIFT_BOX_IMAGE: 'Packaging'
            };
            els.resultImage.innerHTML = state.resultImages.map((item) => `
              <figure>
                <img src="${escapeHtml(item.url)}" alt="${escapeHtml(roleLabels[item.role] || 'AI generated blanket image')}" width="1024" height="1024" loading="lazy">
                <figcaption>${escapeHtml(roleLabels[item.role] || 'Preview')}</figcaption>
              </figure>
            `).join('');
          } else {
            els.resultImage.innerHTML = '';
          }
        }

        if (els.info) {
          const strong = els.info.querySelector('strong');
          const paragraph = els.info.querySelector('p');
          if (paragraph) {
            if (state.aiState === 'empty') {
              paragraph.innerHTML = '<strong>No template selected yet.</strong><br>Choose a template or upload artwork to unlock the AI preview workflow.';
            } else if (state.aiState === 'designed') {
              paragraph.innerHTML = '<strong>AI preview generated.</strong><br>Your blanket, brand mark and packaging direction are ready for review.';
            } else if (state.aiState === 'designing') {
              paragraph.innerHTML = '<strong>AI generation running.</strong><br>The result image will display after the design service response is received.';
            } else if (state.aiState === 'template') {
              paragraph.innerHTML = '<strong>This is a template preview.</strong><br>Review the template images, then click “Start Customizing” to generate the AI result.';
            } else {
              paragraph.innerHTML = '<strong>This is an uploaded image preview.</strong><br>Choose brand mark and packaging options, then click “Start Customizing” to generate the AI result.';
            }
          }
          if (strong) strong.textContent = strong.textContent;
        }

        if (els.summaryTitle) {
          if (state.aiState === 'empty') {
            els.summaryTitle.textContent = 'No Template Selected';
            els.summarySubtitle.textContent = 'Start from a template or your own image';
          } else if (state.aiState === 'uploaded') {
            els.summaryTitle.textContent = 'Uploaded Artwork';
            els.summarySubtitle.textContent = `${state.labelStyle} label · ${state.packagingStyle}`;
          } else if (state.aiState === 'designed') {
            els.summaryTitle.textContent = 'AI Design Ready';
            els.summarySubtitle.textContent = `${state.message || 'No custom text'} · ${state.packagingStyle}`;
          } else {
            els.summaryTitle.textContent = state.selectedTemplate && state.selectedTemplate.name
              ? state.selectedTemplate.name
              : 'Template Selected';
            els.summarySubtitle.textContent = `${state.labelStyle} label · ${state.packagingStyle}`;
          }
        }

        if (els.summaryIncludes) {
          els.summaryIncludes.textContent = `Design, text, ${state.labelStyle}, ${state.packagingStyle}`;
        }

        if (els.summaryPreview) {
          const summaryImage = state.uploadedImage || (state.templateId ? getCurrentTemplateImage('mainEffect') : templateSrc);
          els.summaryPreview.hidden = !summaryImage;
          if (summaryImage) {
            els.summaryPreview.src = summaryImage;
          } else {
            els.summaryPreview.removeAttribute('src');
          }
        }

        if (els.generate) {
          els.generate.disabled = state.aiState === 'designing' || !state.materialPresetId || !state.labelPresetId || !state.packagingPresetId;
          els.generate.innerHTML = state.aiState === 'designed'
            ? 'Continue to Review <span aria-hidden="true">→</span>'
            : state.aiState === 'designing'
              ? 'Waiting for AI Result'
              : 'Start Customizing <span aria-hidden="true">✦</span>';
        }

        if (els.labelState) els.labelState.textContent = state.labelStyle;
        if (els.packagingState) els.packagingState.textContent = state.packagingStyle;
        if (els.autoState) els.autoState.textContent = state.message;
        if (els.styleState) {
          const activeStyle = studio.querySelector('[data-style-choice].is-active')?.getAttribute('data-style-choice');
          els.styleState.textContent = activeStyle === 'double' ? 'Double Layer' : 'Single Layer';
          if (els.styleVisual) {
            els.styleVisual.classList.toggle('design-fabric--double', activeStyle === 'double');
            els.styleVisual.classList.toggle('design-fabric--single', activeStyle !== 'double');
          }
        }
        if (els.sizeState) {
          const activeSize = studio.querySelector('[data-size-choice].is-active')?.getAttribute('data-size-choice') || '50 x 60';
          els.sizeState.textContent = `${activeSize.replace(' x ', '" × ')}"`;
          if (els.sizeVisual) els.sizeVisual.textContent = activeSize.replace(' x ', ' × ');
        }
        if (els.logoState) els.logoState.textContent = state.logoFile ? 'Uploaded' : 'Optional';
        if (els.logoName) els.logoName.textContent = state.logoFile ? state.logoFile.name : 'No logo uploaded';
        if (els.logoSummaryImg && els.logoSummaryEmpty) {
          els.logoSummaryImg.hidden = !state.logoImage;
          els.logoSummaryEmpty.hidden = Boolean(state.logoImage);
          if (state.logoImage) els.logoSummaryImg.src = state.logoImage;
        }
        if (els.sourceName) {
          els.sourceName.textContent = state.uploadedImage
            ? 'Uploaded image selected'
            : state.templateId
              ? state.selectedTemplate && state.selectedTemplate.name ? state.selectedTemplate.name : 'Template image selected'
              : 'Source image needed';
        }
        if (els.sourceStatus) {
          els.sourceStatus.textContent = state.uploadedImage
            ? 'Your uploaded image will be used for the design.'
            : state.templateId
              ? 'The template image will be used for the design.'
              : 'Choose a template image or upload one image.';
        }

        if (els.sourceSummaryImg && els.sourceSummaryEmpty) {
          const sourceSummaryImage = state.uploadedImage || (state.templateId ? getCurrentTemplateImage('mainEffect') : '');
          els.sourceSummaryImg.hidden = !sourceSummaryImage;
          els.sourceSummaryEmpty.hidden = Boolean(sourceSummaryImage);
          if (sourceSummaryImage) els.sourceSummaryImg.src = sourceSummaryImage;
        }

        if (els.labelSummaryImg) {
          const selectedLabelImage = studio.querySelector('[data-label-choice].is-active img');
          els.labelSummaryImg.hidden = !selectedLabelImage;
          if (selectedLabelImage) els.labelSummaryImg.src = selectedLabelImage.src;
        }

        if (els.packagingSummaryImg) {
          const selectedPackagingImage = studio.querySelector('[data-packaging-choice].is-active img');
          els.packagingSummaryImg.hidden = !selectedPackagingImage;
          if (selectedPackagingImage) els.packagingSummaryImg.src = selectedPackagingImage.src;
        }

        studio.querySelectorAll('[data-design-step]').forEach((step) => {
          const stepName = step.getAttribute('data-design-step');
          const isPrepare = (state.aiState === 'empty' || state.aiState === 'template' || state.aiState === 'uploaded') && stepName === 'prepare';
          const isDesigning = state.aiState === 'designing' && stepName === 'designing';
          const isDesigned = state.aiState === 'designed' && stepName === 'designed';
          step.classList.toggle('is-active', isPrepare || isDesigning || isDesigned);
        });
      };

      const setTemplateStatus = (message) => {
        if (els.templateStatus) els.templateStatus.textContent = message;
      };

      const getTemplateLoadErrorMessage = (error, client) => {
        const baseUrl = client && client.config && client.config.baseUrl
          ? client.config.baseUrl
          : 'the configured POPTEX API';
        const message = error && error.message ? error.message : '';

        if (error && error.status === 401) {
          return 'Template API token was rejected. Please refresh and try again.';
        }

        if (error && error.status === 429) {
          return 'Template API is rate limited. Please wait a moment and try again.';
        }

        if (error && error.status === 0 && message.indexOf('timed out') !== -1) {
          return `Template API timed out at ${baseUrl}.`;
        }

        if (error && error.status === 0) {
          return `Cannot connect to template API at ${baseUrl}. Check the API URL, backend service, and CORS.`;
        }

        return message ? `Unable to load templates: ${message}` : 'Unable to load templates. Please try again.';
      };

      const buildTemplateCatalog = (templates) => {
        state.scenes = [];
        state.eventsByScene = {};
        state.templatesByEvent = {};

        templates.forEach((template) => {
          if (!template || !template.id || !template.sceneId || !template.eventId) return;

          if (!state.scenes.some((scene) => scene.id === template.sceneId)) {
            state.scenes.push({
              id: template.sceneId,
              slug: template.sceneSlug,
              name: template.sceneName
            });
          }

          if (!state.eventsByScene[template.sceneId]) {
            state.eventsByScene[template.sceneId] = [];
          }

          if (!state.eventsByScene[template.sceneId].some((event) => event.id === template.eventId)) {
            state.eventsByScene[template.sceneId].push({
              id: template.eventId,
              slug: template.eventSlug,
              name: template.eventName
            });
          }

          if (!state.templatesByEvent[template.eventId]) {
            state.templatesByEvent[template.eventId] = [];
          }

          state.templatesByEvent[template.eventId].push(template);
        });
      };

      const renderSceneButtons = () => {
        if (!els.templateScenes) return;
        els.templateScenes.innerHTML = state.scenes.map((scene) => `
          <button type="button" class="${scene.id === state.selectedSceneId ? 'is-active' : ''}" data-scene-id="${escapeHtml(scene.id)}">
            ${escapeHtml(scene.name || scene.slug || 'Untitled scene')}
          </button>
        `).join('');
      };

      const renderEventButtons = () => {
        if (!els.templateEvents) return;
        const events = state.eventsByScene[state.selectedSceneId] || [];
        const allButton = events.length
          ? `<button type="button" class="${state.selectedEventId ? '' : 'is-active'}" data-event-id="__all__">All templates</button>`
          : '';
        els.templateEvents.innerHTML = allButton + events.map((event) => `
          <button type="button" class="${event.id === state.selectedEventId ? 'is-active' : ''}" data-event-id="${escapeHtml(event.id)}">
            ${escapeHtml(event.name || event.slug || 'Untitled event')}
          </button>
        `).join('');
      };

      const renderTemplateCards = () => {
        if (!els.templateGrid) return;
        const events = state.eventsByScene[state.selectedSceneId] || [];
        const templates = state.selectedEventId
          ? state.templatesByEvent[state.selectedEventId] || []
          : events.flatMap((event) => state.templatesByEvent[event.id] || []);
        els.templateGrid.innerHTML = templates.map((template) => `
          <button type="button" class="design-template-card ${template.id === state.templateId ? 'is-active' : ''}" data-template-id="${escapeHtml(template.id)}">
            ${getTemplateImage(template, 'mainEffect')
              ? `<img src="${escapeHtml(getTemplateImage(template, 'mainEffect'))}" alt="${escapeHtml(template.name || template.slug || 'Template')} main effect preview" width="480" height="360" loading="lazy">`
              : '<div class="design-template-card__empty">No image</div>'}
            <span>
              <strong>${escapeHtml(template.name || template.slug || 'Untitled template')}</strong>
              <small>${escapeHtml(template.sceneName || 'Scene')} · ${escapeHtml(template.eventName || 'Event')} · Version ${escapeHtml(template.version || 1)}</small>
              <p>${escapeHtml(template.description || 'Published template ready for customization.')}</p>
            </span>
            <em>Select template</em>
          </button>
        `).join('');
        setTemplateStatus(templates.length
          ? `${templates.length} published templates loaded.`
          : state.selectedEventId ? 'No published templates found for this event.' : 'No published templates found for this scene.');
      };

      const selectEvent = (eventId) => {
        state.selectedEventId = eventId === '__all__' ? null : eventId;
        renderEventButtons();
        renderTemplateCards();
      };

      const selectScene = (sceneId) => {
        state.selectedSceneId = sceneId;
        state.selectedEventId = null;
        renderSceneButtons();
        renderEventButtons();
        renderTemplateCards();
      };

      const renderTemplateCatalog = () => {
        if (!state.selectedSceneId && state.scenes[0]) {
          state.selectedSceneId = state.scenes[0].id;
        }

        renderSceneButtons();
        renderEventButtons();
        renderTemplateCards();
      };

      const loadTemplateCatalog = (options) => {
        const renderAfterLoad = !options || options.render !== false;
        const api = getTemplateApi();
        const client = getClient();

        if (!api || !api.listTemplates || !client) {
          templateCatalogError = new Error('Template API is not available yet.');
          if (renderAfterLoad) setTemplateStatus(templateCatalogError.message);
          return Promise.reject(templateCatalogError);
        }

        if (state.scenes.length) {
          if (renderAfterLoad) renderTemplateCatalog();
          return Promise.resolve(state.scenes);
        }

        if (templateCatalogPromise) {
          if (renderAfterLoad) setTemplateStatus('Loading templates...');
          return templateCatalogPromise
            .then(() => {
              if (renderAfterLoad) renderTemplateCatalog();
              return state.scenes;
            })
            .catch((error) => {
              if (renderAfterLoad) {
                buildTemplateCatalog([]);
                renderTemplateCatalog();
                setTemplateStatus(getTemplateLoadErrorMessage(error, client));
              }
              throw error;
            });
        }

        catalogRequestId += 1;
        const requestId = catalogRequestId;
        templateCatalogError = null;
        if (renderAfterLoad) setTemplateStatus('Loading templates...');

        templateCatalogPromise = api.listTemplates(client)
          .then((templates) => {
            if (requestId !== catalogRequestId) return state.scenes;
            buildTemplateCatalog(Array.isArray(templates) ? templates : []);
            if (renderAfterLoad) renderTemplateCatalog();
            return state.scenes;
          })
          .catch((error) => {
            console.warn('POPTEX template load failed:', error);
            templateCatalogError = error;
            if (requestId === catalogRequestId && renderAfterLoad) {
              buildTemplateCatalog([]);
              renderTemplateCatalog();
              setTemplateStatus(getTemplateLoadErrorMessage(error, client));
            }
            throw error;
          })
          .finally(() => {
            templateCatalogPromise = null;
          });

        return templateCatalogPromise;
      };

      const openTemplateModal = () => {
        if (!els.templateModal) return;
        els.templateModal.hidden = false;
        loadTemplateCatalog().catch(() => {});
        const closeButton = els.templateModal.querySelector('button[data-template-close]');
        if (closeButton) closeButton.focus();
      };

      const closeTemplateModal = () => {
        if (els.templateModal) els.templateModal.hidden = true;
      };

      const openImageModal = (image, caption) => {
        if (!els.imageModal || !els.imageModalImg || !image || !image.src || image.hidden) return;
        els.imageModalImg.src = image.src;
        els.imageModalImg.alt = image.alt || caption || 'Design preview image';
        if (els.imageModalCaption) els.imageModalCaption.textContent = caption || image.alt || 'Preview image';
        els.imageModal.hidden = false;
      };

      const closeImageModal = () => {
        if (!els.imageModal) return;
        els.imageModal.hidden = true;
        if (els.imageModalImg) {
          els.imageModalImg.src = templateSrc;
          els.imageModalImg.alt = '';
        }
      };

      const selectTemplate = (templateId) => {
        const events = state.eventsByScene[state.selectedSceneId] || [];
        const templates = state.selectedEventId
          ? state.templatesByEvent[state.selectedEventId] || []
          : events.flatMap((event) => state.templatesByEvent[event.id] || []);
        const template = templates.find((item) => item.id === templateId);
        if (!template) return;
        activeRequestId += 1;
        clearInterval(progressTimer);
        state.templateId = template.id;
        state.selectedTemplate = template;
        state.uploadedImage = null;
        state.uploadedFile = null;
        state.resultImage = null;
        state.resultImages = [];
        state.aiState = 'template';
        const templateBlanketStyle = template.defaultConfig && template.defaultConfig.blanketStyle;
        if (templateBlanketStyle === 'single' || templateBlanketStyle === 'double') {
          setActiveInGroup('[data-style-choice]', 'data-style-choice', templateBlanketStyle);
        }
        if (referencePresetsLoaded) {
          applyTemplatePresetDefaults(template);
          renderReferencePresetOptions();
        } else {
          loadReferencePresets().then(() => {
            if (state.templateId !== template.id) return;
            applyTemplatePresetDefaults(template);
            renderReferencePresetOptions();
            render();
          }).catch(() => {});
        }
        if (els.file) els.file.value = '';
        studio.querySelectorAll('[data-template-trigger]').forEach((button) => button.classList.add('is-active'));
        renderTemplateCards();
        render();
        closeTemplateModal();
        showToast(`${template.name || 'Template'} selected`);
      };

      const chooseTemplate = () => {
        openTemplateModal();
      };

      const handleFile = (file) => {
        if (!file) return;
        activeRequestId += 1;
        clearInterval(progressTimer);
        state.templateId = null;
        state.selectedTemplate = null;
        state.selectedSceneId = null;
        state.selectedEventId = null;
        if (referencePresetsLoaded) {
          selectGlobalPresetDefaults();
          renderReferencePresetOptions();
        }
        studio.querySelectorAll('[data-template-trigger]').forEach((button) => button.classList.remove('is-active'));
        studio.querySelectorAll('[data-upload-trigger]').forEach((button) => button.classList.add('is-active'));
        if (file.type === 'application/pdf') {
          state.uploadedImage = templateSrc;
          state.uploadedFile = null;
          state.resultImage = null;
          state.resultImages = [];
          state.aiState = 'uploaded';
          renderTemplateCards();
          render();
          showToast('PDF received for preview');
          return;
        }

        const reader = new FileReader();
        reader.onload = () => {
          state.uploadedImage = reader.result;
          state.uploadedFile = file;
          state.resultImage = null;
          state.resultImages = [];
          state.aiState = 'uploaded';
          renderTemplateCards();
          render();
          showToast('Image uploaded');
        };
        reader.readAsDataURL(file);
      };

      const requestDesignResult = () => {
        const client = window.PoptexApi && window.PoptexApi.getDefaultClient
          ? window.PoptexApi.getDefaultClient()
          : null;

        if (!window.PoptexDesignStudioApi || !window.PoptexDesignStudioApi.requestPreview) {
          return Promise.reject(new Error('POPTEX design service is unavailable'));
        }

        return window.PoptexDesignStudioApi.requestPreview({
          client,
          state,
          onProgress: (caseData) => {
            if (!caseData || !els.progressTitle || !els.progressCopy) return;
            const jobs = caseData.currentGeneration && Array.isArray(caseData.currentGeneration.aiJobs)
              ? caseData.currentGeneration.aiJobs
              : [];
            const mainJob = jobs.find((job) => job.jobType === 'GENERATE_MAIN_EFFECT_IMAGE');
            const gridJob = jobs.find((job) => job.jobType === 'GENERATE_GRID_IMAGE');
            if (mainJob && mainJob.status === 'RUNNING') {
              els.progressTitle.textContent = 'Generating main effect image';
              els.progressCopy.textContent = 'Creating the primary blanket campaign preview.';
            } else if (gridJob && (gridJob.status === 'RUNNING' || gridJob.status === 'RETRYING')) {
              els.progressTitle.textContent = 'Generating four product views';
              els.progressCopy.textContent = 'Creating and validating the product, lifestyle, brand mark and packaging views.';
            } else if (caseData.displayImages && caseData.displayImages.length > 1) {
              els.progressTitle.textContent = 'Validating and cropping';
              els.progressCopy.textContent = 'Preparing five independent images for review.';
            } else {
              els.progressTitle.textContent = 'Design request queued';
              els.progressCopy.textContent = 'The image generation service will start shortly.';
            }
          },
          studioSnapshot: {
            blanketStyle: studio.querySelector('[data-style-choice].is-active')?.getAttribute('data-style-choice') || 'single',
            size: studio.querySelector('[data-size-choice].is-active')?.getAttribute('data-size-choice') || '50 x 60',
            materialPresetId: state.materialPresetId,
            brandMarkPresetId: state.labelPresetId,
            packagingPresetId: state.packagingPresetId
          }
        });
      };

      const startCustomization = (forceRegenerate) => {
        if (state.aiState === 'designed' && !forceRegenerate) {
          showToast('Moving to review step');
          return;
        }

        if (!state.templateId && !state.uploadedImage && state.aiState !== 'template') {
          showToast('Choose a template or upload artwork first');
          return;
        }
        if (!state.materialPresetId || !state.labelPresetId || !state.packagingPresetId) {
          showToast('Material, brand mark, and packaging options are still unavailable');
          return;
        }

        state.aiState = 'designing';
        state.resultImage = null;
        state.resultImages = [];
        activeRequestId += 1;
        const requestId = activeRequestId;
        render();

        const stages = [
          ['Submitting design request', 'Sending selected template, artwork, brand mark, and packaging choices.'],
          ['AI service processing', 'Waiting for the design service to create the preview image.'],
          ['Rendering product context', 'Preparing blanket, brand mark, packaging, and card output.'],
          ['Waiting for image response', 'The result will display when the API returns a final image URL.']
        ];
        let progress = 0;
        clearInterval(progressTimer);
        if (els.progressBar) els.progressBar.style.width = '0%';
        if (els.progressPercent) els.progressPercent.textContent = '0%';
        progressTimer = setInterval(() => {
          progress = Math.min(progress + Math.ceil(Math.random() * 8), 92);
          const stage = stages[Math.min(stages.length - 1, Math.floor(progress / 24))];
          if (els.progressBar) els.progressBar.style.width = `${progress}%`;
          if (els.progressPercent) els.progressPercent.textContent = `${progress}%`;
          if (els.progressTitle) els.progressTitle.textContent = stage[0];
          if (els.progressCopy) els.progressCopy.textContent = stage[1];
        }, 260);

        requestDesignResult()
          .then((result) => {
            if (requestId !== activeRequestId) return;
            clearInterval(progressTimer);
            if (els.progressBar) els.progressBar.style.width = '100%';
            if (els.progressPercent) els.progressPercent.textContent = '100%';
            if (els.progressTitle) els.progressTitle.textContent = 'AI image received';
            if (els.progressCopy) els.progressCopy.textContent = 'The design service returned a preview image.';
            window.setTimeout(() => {
              state.resultImage = result.imageUrl;
              state.resultImages = result.images || [];
              state.aiState = 'designed';
              render();
              showToast(result.partial ? 'Some images need another try' : 'Five AI previews are ready');
            }, 360);
          })
          .catch(() => {
            if (requestId !== activeRequestId) return;
            clearInterval(progressTimer);
            state.aiState = state.uploadedImage ? 'uploaded' : 'template';
            render();
            showToast('AI request failed. Please try again.');
          });
      };

      studio.querySelectorAll('[data-template-trigger]').forEach((button) => {
        button.addEventListener('click', chooseTemplate);
      });

      if (els.templateModal) {
        els.templateModal.querySelectorAll('[data-template-close]').forEach((button) => {
          button.addEventListener('click', closeTemplateModal);
        });
        els.templateModal.addEventListener('click', (event) => {
          const sceneButton = event.target.closest('[data-scene-id]');
          if (sceneButton) {
            catalogRequestId += 1;
            selectScene(sceneButton.getAttribute('data-scene-id'));
            return;
          }

          const eventButton = event.target.closest('[data-event-id]');
          if (eventButton) {
            catalogRequestId += 1;
            selectEvent(eventButton.getAttribute('data-event-id'));
            return;
          }

          const templateButton = event.target.closest('[data-template-id]');
          if (templateButton) {
            selectTemplate(templateButton.getAttribute('data-template-id'));
          }
        });
      }

      const optionModals = Array.from(studio.querySelectorAll('[data-option-modal]'));
      const closeOptionModals = () => {
        optionModals.forEach((modal) => {
          modal.hidden = true;
        });
      };

      studio.querySelectorAll('[data-option-modal-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const modalName = button.getAttribute('data-option-modal-open');
          const modal = studio.querySelector(`[data-option-modal="${modalName}"]`);
          if (!modal) return;
          closeOptionModals();
          modal.hidden = false;
          const closeButton = modal.querySelector('.design-option-modal__dialog [data-option-modal-close]');
          if (closeButton) closeButton.focus();
        });
      });

      optionModals.forEach((modal) => {
        modal.querySelectorAll('[data-option-modal-close]').forEach((button) => {
          button.addEventListener('click', closeOptionModals);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        if (optionModals.some((modal) => !modal.hidden)) {
          closeOptionModals();
          return;
        }
        if (els.imageModal && !els.imageModal.hidden) {
          closeImageModal();
          return;
        }
        if (els.templateModal && !els.templateModal.hidden) {
          closeTemplateModal();
        }
      });

      if (els.imageModal) {
        els.imageModal.querySelectorAll('[data-image-close]').forEach((button) => {
          button.addEventListener('click', closeImageModal);
        });
      }

      if (els.grid) {
        els.grid.addEventListener('click', (event) => {
          const card = event.target.closest('.design-preview-card');
          if (!card || card.classList.contains('is-empty')) return;
          const image = card.querySelector('img:not([hidden])');
          const caption = card.querySelector('figcaption');
          openImageModal(image, caption ? caption.textContent : '');
        });
      }

      if (els.result) {
        els.result.addEventListener('click', (event) => {
          const image = event.target.closest('img');
          if (!image) return;
          const caption = els.result.querySelector('figcaption');
          openImageModal(image, caption ? caption.textContent : '');
        });
      }

      studio.querySelectorAll('[data-upload-trigger]').forEach((button) => {
        button.addEventListener('click', () => els.file && els.file.click());
      });

      if (els.file) {
        els.file.addEventListener('change', (event) => handleFile(event.target.files[0]));
      }

      studio.querySelectorAll('[data-logo-trigger]').forEach((button) => {
        button.addEventListener('click', () => els.logoFile && els.logoFile.click());
      });

      if (els.logoFile) {
        els.logoFile.addEventListener('change', (event) => {
          const file = event.target.files[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = () => {
            state.logoImage = reader.result;
            state.logoFile = file;
            render();
            showToast('Logo uploaded');
          };
          reader.readAsDataURL(file);
        });
      }

      if (els.uploadDrop) {
        ['dragenter', 'dragover'].forEach((eventName) => {
          els.uploadDrop.addEventListener(eventName, (event) => {
            event.preventDefault();
            els.uploadDrop.classList.add('is-dragging');
          });
        });
        ['dragleave', 'drop'].forEach((eventName) => {
          els.uploadDrop.addEventListener(eventName, (event) => {
            event.preventDefault();
            els.uploadDrop.classList.remove('is-dragging');
          });
        });
        els.uploadDrop.addEventListener('drop', (event) => handleFile(event.dataTransfer.files[0]));
      }

      studio.querySelectorAll('[data-style-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          setActiveInGroup('[data-style-choice]', 'data-style-choice', button.getAttribute('data-style-choice'));
          selectMaterialForStyle(button.getAttribute('data-style-choice'));
          render();
        });
      });

      studio.querySelectorAll('[data-size-choice]').forEach((button) => {
        button.addEventListener('click', () => {
          setActiveInGroup('[data-size-choice]', 'data-size-choice', button.getAttribute('data-size-choice'));
          render();
        });
      });

      if (els.brandPresetOptions) {
        els.brandPresetOptions.addEventListener('click', (event) => {
          const button = event.target.closest('[data-label-choice]');
          if (!button) return;
          state.labelStyle = button.getAttribute('data-label-choice');
          state.labelPresetId = button.getAttribute('data-label-preset-id');
          setActiveInGroup('[data-label-choice]', 'data-label-choice', state.labelStyle);
          render();
          closeOptionModals();
        });
      }

      if (els.packagingPresetOptions) {
        els.packagingPresetOptions.addEventListener('click', (event) => {
          const button = event.target.closest('[data-packaging-choice]');
          if (!button) return;
          state.packagingStyle = button.getAttribute('data-packaging-choice');
          state.packagingPresetId = button.getAttribute('data-packaging-preset-id');
          setActiveInGroup('[data-packaging-choice]', 'data-packaging-choice', state.packagingStyle);
          render();
          closeOptionModals();
        });
      }

      const messageInput = studio.querySelector('[data-message-input]');
      if (messageInput) {
        messageInput.addEventListener('input', () => {
          state.message = messageInput.value.trim();
          render();
        });
      }

      if (els.generate) els.generate.addEventListener('click', () => startCustomization(false));
      if (els.regenerate) els.regenerate.addEventListener('click', () => startCustomization(true));

      const previewTrigger = studio.querySelector('[data-design-preview-trigger]');
      if (previewTrigger) previewTrigger.addEventListener('click', () => startCustomization(false));

      studio.querySelectorAll('[data-design-feedback]').forEach((button) => {
        button.addEventListener('click', () => showToast(button.getAttribute('data-design-feedback')));
      });

      render();
      window.setTimeout(() => {
        loadTemplateCatalog({ render: false }).catch(() => {});
        loadReferencePresets().catch(() => {
          renderReferencePresetOptions();
          render();
          showToast('Reference options are unavailable');
        });
      }, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
